import { resolvePath, useLocation } from 'react-router';

export function useCurrentPath() {
  const location = useLocation();
  const referer = resolvePath({ pathname: location.pathname, search: location.search, hash: location.hash });
  return referer;
}
